import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";

import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

//Redux
import { useSelector, useDispatch } from "react-redux";
import {
  getTodaysData,
  validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { getCashRequest } from "../../../../redux/feature/customer_app/customerSlice";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

const CashRequestModel = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  let userData = useSelector((state) => state?.user?.data);
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [getCustomer, setCustomer] = useState([]);
  const [customerID, setCustomerID] = useState("");
  const [getCompanyCode, setCompanyCode] = useState([]);

  /* pop failure modal data*/
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureCashRequest] = useState(failureCashRequest);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
            companyCode: "SVA",

    };
 await ItemService.getCustomersByCompany(obj).then((item) => {
      if (item?.status === 200) {
        setCustomer(item?.data);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });


    // await ItemServiceV2.getCustomers(obj).then((item) => {
    //   // console.log(">> item! title", item);
    //   if (item?.status === 200) {
    //     setCustomer(item?.data);
    //   } else {
    //     setCustomer([]);
    //     console.log(">> Error: Loading getCustomers");
    //   } 
    // });
  };

  const loadMasterData = async () => {

    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };


  //getting customer name
  useEffect(() => {
    getMasterData();
    loadMasterData();
    setCashRequest({
      createdBy: userData?.userId || "",
      cashRequestNr: "",
      cashRequestDate: getTodaysData() || "",
      cashRequestStatus: "Cash in Transit",
      salesOfficerCode: "",
      salesOfficerName: "",
      customerCode: "",
      customerName: "",
      paymentPurpose: "",
      paymentMode: "Cash",
      cashAmount: "",
      cashAmountInWords: "",
      receivedBy: userData?.firstName,
      receiverContactNumber: userData?.contactNumber,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const [cashRequest, setCashRequest] = useState({
    createdBy: userData?.userId || "",
    cashRequestNr: "",
    cashRequestStatus: "Cash in Transit",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: userData?.firstName || "",
    receiverContactNumber: userData?.contactNumber || "",
  });

  //Validations
  const [validation, setValidation] = useState({
    cashRequestNr: "",
    cashRequestStatus: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: "",
    receiverContactNumber: "",
  });
  //Customer drop down

  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));

      setCustomerID(getDropdownData?.id);
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      // getProjectDetailsByCode(getDropdownData?.id);
    } else {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const handleInputChange = ({ target: { name, value } }) => {
    // const { name, value } = event.target;
    const errors = {};
    setCashRequest((cashRequest) => ({ ...cashRequest, [name]: value }));
    // const convertNumberToWords = (num) => {
    //   if (num === "" || isNaN(num)) return "";
    //   num = parseFloat(num).toFixed(2); // Ensure two decimal places
    //   let [rupees, paise] = num.split("."); // Split rupees and paise
    //   rupees = parseInt(rupees);
    //   paise = parseInt(paise);

    //   const ones = [
    //     "",
    //     "One",
    //     "Two",
    //     "Three",
    //     "Four",
    //     "Five",
    //     "Six",
    //     "Seven",
    //     "Eight",
    //     "Nine",
    //     "Ten",
    //     "Eleven",
    //     "Twelve",
    //     "Thirteen",
    //     "Fourteen",
    //     "Fifteen",
    //     "Sixteen",
    //     "Seventeen",
    //     "Eighteen",
    //     "Nineteen",
    //   ];

    //   const tens = [
    //     "",
    //     "",
    //     "Twenty",
    //     "Thirty",
    //     "Forty",
    //     "Fifty",
    //     "Sixty",
    //     "Seventy",
    //     "Eighty",
    //     "Ninety",
    //   ];

    //   const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

    //   const convertBelowThousand = (n) => {
    //     if (n < 20) return ones[n];
    //     if (n < 100)
    //       return (
    //         tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
    //       );
    //     return (
    //       ones[Math.floor(n / 100)] +
    //       " Hundred" +
    //       (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
    //     );
    //   };

    //   let words = "";
    //   let scaleIndex = 0;

    //   while (rupees > 0) {
    //     let part = rupees % 1000;
    //     if (part !== 0) {
    //       words =
    //         convertBelowThousand(part) +
    //         " " +
    //         scales[scaleIndex] +
    //         (words ? " " + words : "");
    //     }
    //     rupees = Math.floor(rupees / 1000);
    //     scaleIndex++;
    //   }

    //   words = words.trim() ? words.trim() + " Rupees" : "";

    //   if (paise > 0) {
    //     let paiseWords = convertBelowThousand(paise) + " Paise";
    //     words += " and " + paiseWords;
    //   }

    //   return words || "Zero Rupees";
    // };
const convertNumberToWords = (num) => {
  if (num === "" || isNaN(num)) return "";
  num = parseFloat(num).toFixed(2);

  let [rupees, paise] = num.split(".");
  rupees = parseInt(rupees);
  paise = parseInt(paise);

  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const convertBelowHundred = (num) => {
    if (num < 20) return ones[num];
    return tens[Math.floor(num / 10)] + (num % 10 ? " " + ones[num % 10] : "");
  };

  const convertBelowThousand = (num) => {
    if (num < 100) return convertBelowHundred(num);
    return (
      ones[Math.floor(num / 100)] +
      " Hundred" +
      (num % 100 ? " " + convertBelowHundred(num % 100) : "")
    );
  };

  const convertIndian = (n) => {
    if (n === 0) return "Zero";

    let result = "";

    const crore = Math.floor(n / 10000000);
    if (crore) {
      result += convertBelowThousand(crore) + " Crore ";
      n %= 10000000;
    }

    const lakh = Math.floor(n / 100000);
    if (lakh) {
      result += convertBelowThousand(lakh) + " Lakh ";
      n %= 100000;
    }

    const thousand = Math.floor(n / 1000);
    if (thousand) {
      result += convertBelowThousand(thousand) + " Thousand ";
      n %= 1000;
    }

    const hundred = n;
    if (hundred) {
      result += convertBelowThousand(hundred) + " ";
    }

    return result.trim();
  };

  let words = convertIndian(rupees);
  words = words ? words + " " : "";

  if (paise > 0) {
    words += " and " + convertIndian(paise) + " ";
  }

  return words || "Zero Rupees";
};

    //passing logic to input fields
    if (name === "cashAmount") {
      if (!isNaN(value) && value !== "") {
        setCashRequest((prev) => ({
          ...prev,
          cashAmount: value,
          cashAmountInWords: convertNumberToWords(value),
        }));
      } else {
        setCashRequest((prev) => ({
          ...prev,
          cashAmount: "",
          cashAmountInWords: "",
        }));
      }
    }

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const modalData = {
    title: "Cash Requested Successfully",
    successMsg: "",
  };

  useEffect(() => {
    setCashRequest({
      ...cashRequest,
        transactionType:"CASH"
    })
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
    // eslint-disable-next-line
  }, [props]);

  const initialState = {
    createdBy: userData?.userId || "",
    cashRequestNr: "",
    cashRequestStatus: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: userData?.firstName,
    receiverContactNumber: userData?.contactNumber,
  };

  //handle cancel modal
  const handleCancel = () => {
    setCashRequest((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };

  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(cashRequest.paymentPurpose)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureCashRequest(true);
      setValidation((prev) => ({
        ...prev,
        paymentPurpose: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(cashRequest.cashAmount)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureCashRequest(true);
      setValidation((prev) => ({
        ...prev,
        cashAmount: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(cashRequest.receivedBy)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureCashRequest(true);
      setValidation((prev) => ({
        ...prev,
        receivedBy: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(cashRequest.receiverContactNumber)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureCashRequest(true);
      setValidation((prev) => ({
        ...prev,
        receiverContactNumber: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    setCashRequest((prev) => ({ ...prev, ...initialState }));
    cashRequest.salesOfficerCode = userData?.userId;
    cashRequest.salesOfficerName = userData?.firstName;
    let obj = {
      data: cashRequest,
      userId: customerID,
    
    };
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    setDisabled(true);
    await ItemServiceV2.addCashRequest(obj).then((item) => {
      if (item?.status === 200) {
        handleSearchFuncApi();
        modalData.successMsg = item?.message;
        props.onHide();
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getCashRequestList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getCashRequest(obj));
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Cash Request
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">CR</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Cash Request</span>
                  <span className="subHeaderTitle">Cash Request details</span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Received Date"
                            name="cashRequestDate"
                            id="cashRequestDate"
                            value={cashRequest?.cashRequestDate}
                            onChange={handleInputChange}
                          // disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
                          <ComboboxField
                            label="Company Name"
                            placeholder=""
                            data={getCompanyCode}
                            id="companyCode"
                            iconClassName="dropdownIcon"
                            name="companyCode"
                            code="companyCode"
                            description="companyCodeDesc"
                            setValue={cashRequest.companyCode || ""}
                            getvalue={setDropdownData}
                            required={true}
                            error={validation.companyCode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Customer Name"
                            placeholder=""
                            data={getCustomer}
                            id="customerName"
                            iconClassName="dropdownIcon"
                            name="customerName"
                            code="customerCode"
                            description="customerNameDesc"
                            setValue={cashRequest.customerName || ""}
                            getvalue={setDropdownData}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Payment Mode"
                            placeholder="Cash"
                            name="defaultCash"
                            id="defaultCash"
                            value={cashRequest.defaultCash || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Cash Amount (INR)"
                            placeholder="Enter amount"
                            name="cashAmount"
                            id="cashAmount"
                            error={validation.cashAmount || ""}
                            value={cashRequest.cashAmount || ""}
                            onChange={handleInputChange}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Cash Amount in Words"
                            placeholder="Cash Amount in Words"
                            name="cashAmountInWords"
                            id="cashAmountInWords"
                            value={cashRequest.cashAmountInWords || ""}
                            disabled={true} // Read-only field
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Received By"
                            name="receivedBy"
                            id="receivedBy"
                            value={cashRequest.receivedBy}
                            error={validation.receivedBy || ""}
                            onChange={handleInputChange || ""}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Receiver contact number"
                            name="receiverContactNumber"
                            id="receiverContactNumber"
                            value={cashRequest.receiverContactNumber || ""}
                            error={validation.receiverContactNumber || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Payment Purpose"
                            name="paymentPurpose"
                            id="paymentPurpose"
                            value={cashRequest.paymentPurpose}
                            error={validation.paymentPurpose || ""}
                            onChange={handleInputChange}
                          // disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default CashRequestModel;
